import { graphqlClient } from "graphql-client/dist/esm"
import { authentication } from "../api/authentication"
import { getSdk } from "./generated/root.graphql"

export const graphqlSdk = graphqlClient({
  url: `${import.meta.env.VITE_DIDIAN_CLIENT_API}/root`,
  getToken: () => authentication.getAuthToken(),
  getSdk,
})
